import { Injectable } from "@angular/core";
import { LocalStoreService } from "./local-store.service";
import { Router } from "@angular/router";
import { of, Observable } from "rxjs";
import { delay } from "rxjs/operators";
import { AppConfig } from "src/app/app.config";
import { Http, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable({
  providedIn: "root"
})
export class AuthService {
  //Only for demo purpose
  authenticated = true;

  constructor(
    private store: LocalStoreService, 
    private router: Router,
    private http: Http, 
    private appConfig: AppConfig) {
    this.checkAuth();
  }

  checkAuth() {
    // this.authenticated = this.store.getItem("demo_login_status");
  }

  getuser() {
    return of({});
  }

  signin(user) {
    return this.http.post(this.appConfig.apiUrl + 'auth/getToken', user)
        .map(res => res.json()).catch((error: any) => Observable.throw(error || 'Bağlantı Hatası'));
  }
  signout() {
    localStorage.removeItem('userToken');
    this.router.navigateByUrl("/sessions/signin");
  }
}
